﻿import {Delegate} from "../Tools/Delegate";

export const OnFetchVersionChanged = new Delegate();